import { useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { useDispatch, useSelector } from 'react-redux';

import { providerActions } from '../../../../../store';
import { getCurrentRelationshipManager } from './utils';

import type { RootState } from '../../../../../store';

export default function useRelationshipManager() {
  const dispatch = useDispatch();
  const { getAccessTokenSilently } = useAuth0();
  const { provider, relationshipManagers, relationshipManagersLoading } = useSelector(
    (state: RootState) => state.providers,
  );

  useEffect(() => {
    if (!provider?.id) return;

    dispatch(
      providerActions.getRelationshipManagers({
        guardianProviderId: provider.id,
        getAccessTokenSilently,
      }),
    );
  }, [dispatch, getAccessTokenSilently, provider?.id]);

  return {
    loading: relationshipManagersLoading,
    relationshipManager: getCurrentRelationshipManager(relationshipManagers),
  };
}
